The keywords to search SEEK's library of application questions with.
